import React, { useState } from "react";
import { Container, Col, Row, Nav } from "react-bootstrap";
import Sidebar from "../Sidebar";
import { ToastContainer } from "react-toastify";
import { Breadcrumbs } from "../Breadcrumb";
import { POMcard } from "./POMcard";

export const ProductOfMonth = () => {
  const [index, setIndex] = useState(0);

  return (
    <>
      <Container fluid>
        <Row>
          <Sidebar />
          <Col lg={10} style={{ backgroundColor: "#f1f2f3" }}>
            <Row className="p-4">
              <Col className="slidesContent rounded shadow p-3 bg-light">
                <Breadcrumbs currentPathName="Product Of The Month" />
                <div className="tabList">
                  <Nav variant="tabs" defaultActiveKey={0}>
                    <Nav.Item onClick={() => setIndex(0)}>
                      <Nav.Link eventKey={0}>FIRST PRODUCT</Nav.Link>
                    </Nav.Item>
                    <Nav.Item onClick={() => setIndex(1)}>
                      <Nav.Link eventKey={1}>SECOND PRODUCT</Nav.Link>
                    </Nav.Item>
                    <Nav.Item onClick={() => setIndex(2)}>
                      <Nav.Link eventKey={2}>THIRD PRODUCT</Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
                <div className="tabContent" hidden={index !== 0}>
                  <POMcard serialNo={1} />
                </div>
                <div className="tabContent" hidden={index !== 1}>
                  <POMcard serialNo={2} />
                </div>
                <div className="tabContent" hidden={index !== 2}>
                  <POMcard serialNo={3} />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
      <ToastContainer />
    </>
  );
};
